import * as React from 'react';

import { cn, Col, Separator } from '@rematter/ui-web';

import { useSettingsLocation } from '../../_state/settingsModule.state';
import { MenuItemGroup } from '../../_types';
import { useTranslations } from '../../i18n/useTranslations';
import { SettingsPath } from '../../routes';
import { SettingsLink } from '../_shared/SettingsLink';
export type MenuGroupProps = { group: MenuItemGroup; index: number };

export const MenuGroup = ({ group, index }: MenuGroupProps) => {
  const t = useTranslations();
  const [location] = useSettingsLocation();

  const visibleItems = React.useMemo(
    () =>
      group.items
        .filter(({ hideFromMenu }) => !hideFromMenu)
        .map((item) => {
          const patterns = Array.isArray(item.pattern)
            ? item.pattern
            : [item.pattern];
          const isActive = patterns.some((p) => p.startsWith(location));
          const firstPattern = patterns[0];
          const key = item.label.i18nKey;
          const resolvedLabel =
            (t.settingsLayout.routeLabels as Record<string, string>)[key] ??
            (t.hardwareView.routeLabels as Record<string, string>)[key] ??
            key;
          return {
            ...item,
            isActive,
            href: firstPattern as SettingsPath,
            resolvedLabel,
          };
        }),
    [group.items, location, t],
  );

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <Col className="@MenuGroup" gap2>
      {group.groupTitle && (
        <div className={'text-xs font-medium text-current/50'}>
          {t.settingsLayout.groupTitles[group.groupTitle.i18nKey]}
        </div>
      )}
      {!group.groupTitle && index > 0 && (
        <Separator className={'mt-0.5 mb-1.5 opacity-15'} />
      )}
      <Col className={'gap-[2px]'}>
        {visibleItems.map(
          ({ icon: Icon, href, isActive, disabled, resolvedLabel }) => (
            <SettingsLink
              key={href}
              href={href}
              className={cn(
                'flex cursor-pointer items-center gap-1.5 rounded-sm p-2 text-sm font-medium hover:bg-current/8',
                isActive && 'bg-foreground! text-space',
                disabled && 'line-through opacity-40',
              )}
            >
              {Icon && <Icon size={16} className={'opacity-50'} />}{' '}
              {resolvedLabel}
            </SettingsLink>
          ),
        )}
      </Col>
    </Col>
  );
};
